/**
 * 고객 이용문의 통계 페이지
 */

import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Card, Badge } from 'react-bootstrap';
import AdminLayout from '../../components/layout/AdminLayout';
import { inquiryService } from '../../services/inquiryService';
import { InquiryStats as InquiryStatsType } from '../../types/inquiry';
import FilterBar, { FilterField } from '../../components/common/FilterBar';

const InquiryStats: React.FC = () => {
  const [filter, setFilter] = useState<{ start_date?: string; end_date?: string }>({});

  const { data: stats, isLoading } = useQuery({
    queryKey: ['inquiryStats', filter],
    queryFn: () => inquiryService.getInquiryStats(filter),
  });

  const filterFields: FilterField[] = [
    {
      name: 'start_date',
      label: '시작일',
      type: 'date',
    },
    {
      name: 'end_date',
      label: '종료일',
      type: 'date',
    },
  ];

  const handleFilterChange = (values: Record<string, any>) => {
    setFilter({
      start_date: values.start_date || undefined,
      end_date: values.end_date || undefined,
    });
  };

  if (isLoading) {
    return (
      <AdminLayout>
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div>
        <h1 style={{ color: '#fff' }} className="mb-4">고객 이용문의 통계</h1>

        <Card className="mb-4">
          <Card.Body>
            <FilterBar
              fields={filterFields}
              values={filter}
              onChange={handleFilterChange}
              onSearch={() => {}}
              onReset={() => setFilter({})}
            />
          </Card.Body>
        </Card>

        <div className="row mb-4">
          <div className="col-md-3">
            <Card>
              <Card.Body>
                <h6>전체 문의</h6>
                <h2 style={{ color: '#00BCD4' }}>{stats?.total_count || 0}</h2>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-3">
            <Card>
              <Card.Body>
                <h6>대기중</h6>
                <h2 style={{ color: '#ffc107' }}>{stats?.pending_count || 0}</h2>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-3">
            <Card>
              <Card.Body>
                <h6>처리중</h6>
                <h2 style={{ color: '#0dcaf0' }}>{stats?.in_progress_count || 0}</h2>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-3">
            <Card>
              <Card.Body>
                <h6>완료</h6>
                <h2 style={{ color: '#198754' }}>{stats?.completed_count || 0}</h2>
              </Card.Body>
            </Card>
          </div>
        </div>

        {stats?.average_response_time && (
          <Card className="mb-4">
            <Card.Body>
              <h5>평균 응대 시간</h5>
              <h3 style={{ color: '#00BCD4' }}>
                {Math.round(stats.average_response_time)} 분
              </h3>
            </Card.Body>
          </Card>
        )}

        {stats?.by_type && Object.keys(stats.by_type).length > 0 && (
          <Card>
            <Card.Body>
              <h5>문의 유형별 통계</h5>
              <div className="mt-3">
                {Object.entries(stats.by_type).map(([type, count]) => (
                  <div key={type} className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ color: '#ccc' }}>{type}</span>
                    <Badge bg="primary">{count}</Badge>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>
        )}
      </div>
    </AdminLayout>
  );
};

export default InquiryStats;

